@if(isExpired){
  <div class="main-not-found">
    <div class="main-not-found-content">
      <img src="../../assets/images/expired-resume.svg" alt="Expired resume" />
      <span> Whoopsie! </span>
      <span> The resume link has expired. </span>
      <span class="main-not-found-contact"
        >Please contact the recruiter for any inquiries.</span
        >
      </div>
    </div>
  } @else if (userData) {
    <div class="main">
      @if(!isHeaderVisible && !mobile){
        <div nz-row class="header">
          <div nz-col nzXs="20" nzSm="20" nzMd="20" nzLg="20" style="display: flex">
            <div class="left-bar">
              <nz-avatar [nzSize]="50"
                nzIcon="user"
					[nzSrc]="userData.data.header.profilePicture ?? ''"
               />
            </div>
            <div class="jx-content">
              <span class="jx-name"
                >{{ isFirstNameView ? userData.data.header.firstName : '' }}
                {{ isLastNameView ? userData.data.header.lastName : '' }}
                @if(userData.data.header.csUserName !== null){
                  <span> ({{ userData.data.header.csUserName }}) </span>
                  }</span
                  >
                  <span class="jx-title">{{ latestJobTitle }}</span>
                </div>
              </div>
              <div nz-col nzXs="4" nzSm="4" nzMd="4" nzLg="4" class="header-jx-id">
                <span style="text-align: right; padding-right: 20px">{{
                  userData.data.header.jxId
                }}</span>
              </div>
            </div>
          }

          <div nz-row nzGutter>
            @if(!mobile){
              @if (sidebarSetting?.active) {
                <div
                  class="sidebar no-print"
                  nz-col
                  nzXs="24"
                  nzSm="24"
                  nzMd="9"
                  nzLg="9"
                  >
                  <app-sidebar [settings]="sidebarSetting!.fields"
                    [sidebar]="userData.data.sidebar"
                   />
                </div>
              }
            }

            <div class="main-content" nz-col nzXs="24" nzSm="24" nzMd="15" nzLg="15">
              <div class="content-header-wrapper" #hideShowHeader>
                @if (headerSetting?.active) {
                  <app-content-header [header]="userData.data.header"
                    [cvId]="userData.id"
                    [latestJobTitle]="latestJobTitle"
                    [settings]="headerSetting!.fields"
                   />
                }
              </div>
              @if(mobile){
                @if (sidebarSetting?.active) {
                  <div class="sidebar">
                    <app-sidebar [sidebar]="userData.data.sidebar"
                      [settings]="sidebarSetting!.fields"
                     />
                  </div>
                }
              }
              @if (sidebarSetting?.active) {
                <div class="academic-wrapper print">
                  <app-sidebar [settings]="sidebarSetting!.fields"
                    [sidebar]="userData.data.sidebar"
                   />
                </div>
              }
              @if (academicSetting?.active) {
                <div class="academic-wrapper">
                  <app-academic [academic]="userData.data.academic"
                    [settings]="academicSetting!.fields"
                   />
                </div>
              }
              @if (experienceSetting?.active) {
                <div class="experience-wrapper">
                  <app-experience [experience]="userData.data.experience"
                    [settings]="experienceSetting!.fields"
                    [isExpLabelShow]="isExpLabelShow"
                   />
                </div>
              }
              @if (skillSetting?.active || AIskillSetting?.active) {
                <div class="skills-wrapper">
                  <app-skills [skills]="skillsData"
                    [settings]="skillSetting?.fields"
                    [aiSettings]="AIskillSetting?.fields"
                   />
                </div>
              }
              @if (applicationSetting?.active) {
                <div class="application-wrapper">
                  <app-application-history [application]="userData.data.applicationHistories"
                    [settings]="applicationSetting!.fields"
                   />
                </div>
              }
            </div>
          </div>
        </div>
      }
